class SubscriptionVariantSwitcher {
  constructor() {
    this.DEBUG = true;
    document.addEventListener("DOMContentLoaded", () => {
      this.log("Initializing SubscriptionVariantSwitcher");

      // Load productData
      const productDataElement = document.getElementById("productData");
      if (!productDataElement) {
        this.error(
          "productData element not found. Ensure <script id='productData'> exists with product JSON."
        );
        return;
      }

      try {
        this.productData = JSON.parse(productDataElement.textContent);
      } catch (e) {
        this.error("Failed to parse productData JSON", e);
        return;
      }

      this.init();
    });
  }

  init() {
    this.log("Setting up subscription items");

    // Get all cart items
    const cartItems = document.querySelectorAll(".cart-item");

    cartItems.forEach((cartItem) => {
      // Check if this is a subscription item
      const isSubscription = cartItem.querySelector(
        ".subscription-variant-selector"
      );

      if (isSubscription) {
        this.log("Found subscription item, hiding controls");

        // Mark as subscription item
        cartItem.classList.add("subscription-item");

        // Hide the subscription variant selector
        const select = cartItem.querySelector(".subscription-variant-selector");
        if (select) {
          select.style.display = "none";
        }

        // Hide the quantity input
        const quantityInput = cartItem.querySelector("quantity-input");
        if (quantityInput) {
          quantityInput.style.display = "none";
        }
      }
    });
  }

  log(message, data = null) {
    if (!this.DEBUG) return;
    const timestamp = new Date().toISOString();
    if (data) {
      console.log(
        `[SubscriptionVariantSwitcher ${timestamp}] ${message}`,
        data
      );
    } else {
      console.log(`[SubscriptionVariantSwitcher ${timestamp}] ${message}`);
    }
  }

  error(message, err = null) {
    if (!this.DEBUG) return;
    const timestamp = new Date().toISOString();
    console.error(
      `[SubscriptionVariantSwitcher ERROR ${timestamp}] ${message}`,
      err
    );
  }
}

// Initialize the class
new SubscriptionVariantSwitcher();
